<div class="wrap">
  <div class="header">
    <div class="title">
      <mat-label [routerLink]="['/admin']" routerLinkActive="router-link-active">
        <fa-icon [icon]="faChevronLeft"></fa-icon>
        <h2>Liste des notifications</h2>
      </mat-label>
    </div>

    <div class="add_search_notif_mobile">

      <div class="search_bar">
        <form [formGroup]="searchForm">
          <input type="text" placeholder="Chercher une notification ..." (input)="applyFilter($event.target)"
            formControlName="keyword">

        </form>

        <fa-icon [icon]="faTimes" (click)="resetSearch()" class="faTimes" *ngIf="valueInput"></fa-icon>
        <fa-icon [icon]="faSearch" *ngIf="!valueInput"></fa-icon>

      </div>
      <div class="add_notif" (click)="openDialogAddNotification()">
        <fa-icon [icon]="faPlus"></fa-icon>
        <span>Ajouter une notification</span>
      </div>
    </div>

    <div class="add_search_notif_desktop">
      <div class="add_notif" (click)="openDialogAddNotification()">
        <fa-icon [icon]="faPlus"></fa-icon>
        <span>Ajouter une notification</span>
      </div>
      <div class="search_bar">
        <form [formGroup]="searchForm">
          <input type="text" placeholder="Chercher une notification ..." (input)="applyFilter($event.target)"
            formControlName="keyword">

        </form>

        <fa-icon [icon]="faTimes" (click)="resetSearch()" class="faTimes" *ngIf="valueInput"></fa-icon>
        <fa-icon [icon]="faSearch" *ngIf="!valueInput"></fa-icon>

      </div>
    </div>
  </div>

  <div class="content">
    <div class="table_mobile">
      <table mat-table matSort [dataSource]="dataSource"  multiTemplateDataRows class="mat-elevation-z8">
  
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="startDate" > Date</th>
          <td mat-cell *matCellDef="let element" > {{element?.sendDate | date: "short" }} </td>
        </ng-container>
        
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="title"> Titre
          </th>
          <td mat-cell *matCellDef="let element"> {{element?.title}} </td>
        </ng-container>
  
        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef > supp.
          </th>
          <td mat-cell *matCellDef="let element" >
            <fa-icon [icon]="faTrashAlt" (click)="openDialogDeleteItem(element.id)"></fa-icon>
          </td>
        </ng-container>
  
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnsMobile.length">
            <div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
              <div class="push_details">
                <div class="title">
                  <h2>{{element.title}}  -</h2>
                  <span>{{element.topic}}</span>
                </div>
                <p>{{element.body}}</p>
              </div>
            </div>
          </td>
        </ng-container>
      
        <tr mat-header-row *matHeaderRowDef="displayedColumnsMobile" ></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumnsMobile;" class="example-element-row"
          [class.example-expanded-row]="expandedElement === element"
          (click)="updateExpandedElement(element)" >
        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row" ></tr>
      </table>
    </div>

    <div class="table_desktop">
      <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8 ">
  
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="date" class="cell_medium"> Date</th>
          <td mat-cell *matCellDef="let element" class="cell_medium"> {{element?.sendDate | date: "short" }} </td>
        </ng-container>
  
        <ng-container matColumnDef="topic">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="topic" class="cell_medium"> Topic
          </th>
          <td mat-cell *matCellDef="let element" class="cell_medium"> {{element?.topic}} </td>
        </ng-container>
  
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="title"> Titre
          </th>
          <td mat-cell *matCellDef="let element"> {{element?.title}} </td>
        </ng-container>
  
        <ng-container matColumnDef="body">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="body"> Texte
          </th>
          <td mat-cell *matCellDef="let element"> {{element?.body}} </td>
        </ng-container>
  
        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef class="cell_action"> supp.
          </th>
          <td mat-cell *matCellDef="let element" class="cell_action">
            <fa-icon [icon]="faTrashAlt" (click)="openDialogDeleteItem(element.id)"></fa-icon>
          </td>
        </ng-container>
  
  
        <tr mat-header-row *matHeaderRowDef="displayedColumnsDesktop"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsDesktop;"> </tr>
      </table>
    </div>
  
    <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
      (page)="pageEvent = $event" [color]="color">
    </mat-paginator>
  </div>
</div>
